import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const defaultRenderFunctions = {
  button: props => {
    return /*#__PURE__*/_jsx("button", {
      type: "button",
      ...props
    });
  },
  div: props => {
    return /*#__PURE__*/_jsx("div", {
      ...props
    });
  },
  h2: props => {
    return /*#__PURE__*/_jsx("h2", {
      ...props
    });
  },
  h3: props => {
    return /*#__PURE__*/_jsx("h3", {
      ...props
    });
  },
  output: props => {
    return /*#__PURE__*/_jsx("output", {
      ...props
    });
  },
  p: props => {
    return /*#__PURE__*/_jsx("p", {
      ...props
    });
  },
  span: props => {
    return /*#__PURE__*/_jsx("span", {
      ...props
    });
  },
  a: props => {
    return /*#__PURE__*/_jsx("a", {
      ...props
    });
  },
  label: props => {
    return /*#__PURE__*/_jsx("label", {
      ...props
    });
  },
  input: props => {
    return /*#__PURE__*/_jsx("input", {
      ...props
    });
  },
  fieldset: props => {
    return /*#__PURE__*/_jsx("fieldset", {
      ...props
    });
  },
  form: props => {
    return /*#__PURE__*/_jsx("form", {
      ...props
    });
  },
  img: props => {
    return /*#__PURE__*/_jsx("img", {
      alt: "",
      ...props
    });
  }
};